module.exports = __webpack_public_path__ + "img/lunbo241.6bcd933.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo241.png
// module id = YXId
// module chunks = 0